"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metaContainsKey = void 0;
const metaContainsKey = (meta, key) => {
    return meta?.some((meta) => meta.key === key && meta.value) ?? false;
};
exports.metaContainsKey = metaContainsKey;
